import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes'
import store from '@/store'
import * as R from 'ramda'

Vue.use(Router)

export const homePath = '/'
export const loginPath = '/login'
export const passwordSettingPath = '/password-setting'

const isLoginRoute = R.propEq('path', loginPath)
const hasMatchedRoutes = R.pathSatisfies(R.gt(R.__, 0), ['matched', 'length'])

/**
 * check if user have appropriate scope for access to route
 */
const isRouteAvailable = (route) => {
  let userScopes = R.path(['getters', 'userScopes'], store)
  if (R.isEmpty(userScopes)) store.dispatch('decodeUserScopes')
  let userRole = R.path(['getters', 'getUserRole'], store)
  const roleScope = R.pathOr([], ['meta', 'roleScope'], route)
  return roleScope.includes(userRole)
}

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 50)
    })
  }
})

router.beforeEach((to, from, next) => {
  const isSetPasswordPath = to.path === passwordSettingPath
  const isLoggedIn = R.path(['getters', 'isLoggedIn'], store)
  const hasMatching = hasMatchedRoutes(to)
  const isGoingToLogin = isLoginRoute(to)
  const isProtectedRoute = R.not(isGoingToLogin) && !isSetPasswordPath
  const isHomeOrLoginPath = to.path === homePath || to.path === loginPath
  const isUserHasAccess = isSetPasswordPath || isHomeOrLoginPath || isRouteAvailable(to)
  if (hasMatching) {
    if (isGoingToLogin && isLoggedIn) {
      next(homePath)
    }
    if (isProtectedRoute && !isLoggedIn) {
      next(loginPath)
    }
    isUserHasAccess ? next() : next(loginPath)
  } else {
    const path = isLoggedIn ? homePath : loginPath
    next(path)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js